import { css } from 'styled-components'

export default function ({
  headingWrapperProps,
  imageWrapperProps,
}) {
  return {
    triangleProps: {
      clipReversed: false,
      clipDisabled: false,
    },
    wrapperProps: {
      mobileWrapperStyles: css`
        margin-bottom: 100px;
        padding-top: 45px;
      `,
      tabletWrapperStyles: css`
        overflow: hidden;
      `,
      desktopWrapperStyles: css`
        overflow: inherit;
        padding-bottom: 0;
      `,
    },
    containerProps: {
      mobileContainerStyles: {},
      tabletContainerStyles: {},
      desktopContainerStyles: css`
        flex-direction: row-reverse;
      `,
    },
    headingWrapperProps: {
      ...headingWrapperProps,
      desktopContainerStyles: css`
        width: 55%;
      `,
    },
    imageWrapperProps: {
      ...imageWrapperProps,
      mobileImageWrapperStyles: css`
        margin-bottom: -80px;
        margin-top: 40px;
      `,
      tabletImageWrapperStyles: css`
        margin-bottom: -75px;
        margin-top: 25px; /* +50px margin in image */
      `,
      desktopImageWrapperStyles: css`
        margin-bottom: -25px;
        width: 80%;
      `,
      mobileImageStyles: css`
        /* margin-left: -${ ({ theme }) => (theme.gridGutterMobile * 3.4) / 2 }px; */
        margin-left: -8%;
        /* width: calc(100% + ${ ({ theme }) => theme.gridGutterMobile * 3.4 }px); */
        position: relative;
        width: 116%;
        z-index: 100; 
      `,
      tabletImageStyles: css`
        left: 3%;
        width: 140%;
        z-index: 0;
      `,
      desktopImageStyles: css`
        margin-left: -33%;
        margin-right: 0;
        width: auto;
        z-index: 100;
      `,
    },
  }
}
